import { gql } from '@apollo/client';

// Web-Redirect-URLs für das Stripe-Onboarding. Müssen ZEICHENGENAU einem Eintrag der
// Backend-Allowlist (STRIPE_ALLOWED_RETURN_URLS / STRIPE_ALLOWED_REFRESH_URLS) entsprechen.
// Env devbackend → stu-studio.de.  ACHTUNG: für prod auf stu-studios.de umstellen.
export const STRIPE_WEB_RETURN_URL = 'https://stu-studios.de/stripe-return?stripe_return=true';
export const STRIPE_WEB_REFRESH_URL = 'https://stu-studios.de/stripe-return?stripe_refresh=true';

// Stripe / Payout status for the current user
export const GET_USER_STRIPE_STATUS = gql`
  query GetUserStripeStatus($id: ID!) {
    getUser(id: $id) {
      id
      email
      stripeConnectAccountId
      stripeOnboardingComplete
      stripePayoutsEnabled
      stripeChargesEnabled
      stripeAccountStatus
    }
  }
`;

// Create a new Stripe Connected Account (starts onboarding flow)
export const CREATE_CONNECTED_ACCOUNT = gql`
  mutation CreateConnectedAccount($input: CreateConnectedAccountInput!) {
    createConnectedAccount(input: $input) {
      success
      accountId
      onboardingUrl
      error
    }
  }
`;

// Create (or resume) an onboarding link for an existing account
export const CREATE_ONBOARDING_LINK = gql`
  mutation CreateOnboardingLink($accountId: String!, $returnUrl: String, $refreshUrl: String) {
    createOnboardingLink(accountId: $accountId, returnUrl: $returnUrl, refreshUrl: $refreshUrl) {
      url
      expiresAt
    }
  }
`;

// Aggregate payout information (available / pending balances, next payout)
export const GET_PAYOUT_INFO = gql`
  query GetPayoutInfo {
    getPayoutInfo {
      available {
        amount
        currency
      }
      pending {
        amount
        currency
      }
      nextPayoutDate
      nextPayoutAmount
      queuedPayoutAmount
      queuedPayoutCount
      failedPayoutAmount
      payoutsEnabled
      accountStatus
      chargesEnabled
      detailsSubmitted
      canReceivePayouts
    }
  }
`;

// Host finance data (used for extended finance dashboards / charts)
export const GET_HOST_FINANCE_DATA = gql`
  query GetHostFinanceData($studioOwnerID: ID!, $limit: Int, $nextToken: String) {
    bookingsByStudioOwnerID(
      studioOwnerID: $studioOwnerID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        paymentStatus
        totalPrice
        totalStudioPrice
        totalCreativePrice
        platformFeeAmount
        hostPayoutAmount
        stripeTransferId
        startDateTime
        endDateTime
        projectName
        createdAt
        studioID
        userID
        Studio {
          id
          StudioName
          city
          image
          images
        }
      }
      nextToken
    }
  }
`;

// Query for user payments (as guest/booker)
export const GET_USER_PAYMENTS = gql`
  query GetUserPayments($userID: ID!, $limit: Int, $nextToken: String) {
    bookingsByUserID(
      userID: $userID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        paymentStatus
        totalPrice
        totalStudioPrice
        totalCreativePrice
        startDateTime
        endDateTime
        projectName
        createdAt
        studioID
        Studio {
          id
          StudioName
          studioLocation
          city
          image
          images
        }
      }
      nextToken
    }
  }
`;

// Query for user income (as host/studio-owner)
export const GET_USER_INCOME = gql`
  query GetUserIncome($studioOwnerID: ID!, $limit: Int, $nextToken: String) {
    bookingsByStudioOwnerID(
      studioOwnerID: $studioOwnerID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        paymentStatus
        totalPrice
        totalStudioPrice
        totalCreativePrice
        platformFeeAmount
        hostPayoutAmount
        stripeTransferId
        startDateTime
        endDateTime
        projectName
        createdAt
        userID
        studioID
        User {
          id
          firstName
          lastName
          profilePicture
        }
        Studio {
          id
          StudioName
          studioLocation
          city
          image
          images
        }
      }
      nextToken
    }
  }
`;

// Single booking for receipt details
export const GET_BOOKING_FOR_RECEIPT = gql`
  query GetBookingForReceipt($id: ID!) {
    getBooking(id: $id) {
      id
      status
      paymentStatus
      paymentIntentID
      totalPrice
      totalStudioPrice
      totalCreativePrice
      startDateTime
      endDateTime
      projectName
      projectDescription
      companyName
      numberOfGuests
      createdAt
      updatedAt
      creativePackages {
        packageID
        packageName
        packageType
        price
        specialRequests
      }
      studioID
      userID
      studioOwnerID
      Studio {
        id
        StudioName
        studioLocation
        city
        postcode
        country
        approxLatitude
        approxLongitude
        locationLabel
        locationPrecision
        image
        images
        pricePerHour
        User {
          id
          firstName
          lastName
        }
      }
      User {
        id
        firstName
        lastName
      }
    }
  }
`;
